import type React from "react"
import { useState } from "react"
import { Bot, FileAudio, FileText } from "lucide-react"
import { useTranslation } from "react-i18next"

interface AIServiceInfoProps {
  isAI: boolean
  prompt?: string
  audioUrl?: string
}

const AIServiceInfo: React.FC<AIServiceInfoProps> = ({ isAI, prompt, audioUrl }) => {
  const [showInfo, setShowInfo] = useState(false)
  const { t } = useTranslation();

  if (!isAI) return null

  return (
    <div className="mt-4">
      <button
        onClick={() => setShowInfo(!showInfo)}
        className="flex items-center space-x-2 text-blue-600 hover:text-blue-800"
      >
        <Bot size={20} />
        <span>{t('ai_generated')}</span>
      </button>
      {showInfo && (
        <div className="mt-2 p-4 bg-gray-100 rounded-md">
          {prompt && (
            <div className="flex items-start space-x-2 mb-2">
              <FileText size={20} className="text-gray-600 mt-1" />
              <p className="text-gray-800">{prompt}</p>
            </div>
          )}
          {audioUrl && (
            <div className="flex items-center space-x-2">
              <FileAudio size={20} className="text-gray-600" />
              <audio controls src={process.env.REACT_APP_AUDIO_STORAGE+"/"+audioUrl} className="w-full" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default AIServiceInfo

